// Google-Maps-style "pegman" figure — the shared street-view person icon. Inner SVG markup only;
// render it inside an <svg viewBox="0 0 44 68">…</svg>. Single source for the ModelViewer / ViewAsset
// street-view handle and the findings "Street view" affordances.
export const PEGMAN_SVG = `
  <ellipse cx="22" cy="16.6" rx="12.6" ry="3.1" fill="#e9a417"/>
  <path d="M13.2 16.6 a8.8 8.8 0 0 1 17.6 0 z" fill="#ffc62e"/>
  <path d="M15 16.6 a7 7 0 0 1 7 -6.8 l0 6.8 z" fill="#ffdc6b"/>
  <rect x="21" y="9.6" width="2" height="7" rx="1" fill="#e9a417"/>
  <circle cx="22" cy="22.4" r="5.2" fill="#eab98d"/>
  <path d="M17 23.2 a5.2 5.2 0 0 0 10 0 z" fill="#d9a578" opacity="0.5"/>
  <rect x="19.5" y="26" width="5" height="3" rx="1.5" fill="#d9a578"/>
  <rect x="13.6" y="27.6" width="16.8" height="21" rx="6.5" fill="#2c313c"/>
  <rect x="12.9" y="28.5" width="18.2" height="19.4" rx="6.2" fill="#ddf23a"/>
  <path d="M19 28.7 l3 3 l3 -3 z" fill="#2c313c"/>
  <rect x="21.6" y="31" width="0.8" height="16.6" fill="#aeb90f"/>
  <rect x="11.8" y="34.4" width="20.4" height="2.6" rx="1.1" fill="#d7e1e8"/>
  <rect x="11.8" y="40.2" width="20.4" height="2.6" rx="1.1" fill="#d7e1e8"/>
  <rect x="8.7" y="29" width="5" height="15.2" rx="2.5" fill="#2c313c"/>
  <rect x="30.3" y="29" width="5" height="15.2" rx="2.5" fill="#2c313c"/>
  <rect x="8.7" y="40.6" width="5" height="3.1" rx="1.4" fill="#ddf23a"/>
  <rect x="30.3" y="40.6" width="5" height="3.1" rx="1.4" fill="#ddf23a"/>
  <circle cx="11.2" cy="45.4" r="2.5" fill="#23272f"/>
  <circle cx="32.8" cy="45.4" r="2.5" fill="#23272f"/>
  <rect x="15.4" y="47.6" width="5.6" height="15.6" rx="2.3" fill="#3a4150"/>
  <rect x="23" y="47.6" width="5.6" height="15.6" rx="2.3" fill="#3a4150"/>
  <rect x="13.4" y="60" width="8" height="4.7" rx="2.3" fill="#17191f"/>
  <rect x="22.6" y="60" width="8" height="4.7" rx="2.3" fill="#17191f"/>
  <rect x="13.4" y="63.2" width="8" height="1.5" rx="0.7" fill="#454b55"/>
  <rect x="22.6" y="63.2" width="8" height="1.5" rx="0.7" fill="#454b55"/>
`;
